import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {connect, getStore} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../config/design/TableIcons";
import {Link, withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../../config/Permissions";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import AppCardLoaderTable from "../../../components/Skeletons/AppCardLoaderTable";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {colors, currencySymbol} from "../../../../config/values";
import CurrencyFormat from "react-currency-format";
import Button from "@material-ui/core/Button/Button";
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import RemoveRoundedIcon from '@material-ui/icons/RemoveRounded';
import ViewUserBankInfo from "../users/components/ViewUserBankInfo";
import RemoveCircleRoundedIcon from '@material-ui/icons/RemoveCircleRounded';
import CreditCardRoundedIcon from '@material-ui/icons/CreditCardRounded';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import PayWalletButton from "./PayWalletButton";
import GetConfirmationText from "../../../components/elements/GetConfirmationText";
import SubTitleLight from "../../../components/elements/SubTitleLight";
import Grid from "@material-ui/core/Grid/Grid";
import ChooseDate from "../../../components/elements/ChooseDate";
import TextField from "@material-ui/core/TextField/TextField";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import FilterListRoundedIcon from "@material-ui/icons/FilterListRounded";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import PublishRoundedIcon from "@material-ui/icons/PublishRounded";
class Wallet extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            { title: Translate.code,
                field: 'unique_code',
                filterPlaceholder: Translate.search,
                editable: 'never',
            },
            {
                field: 'type',
                editable: 'never',
                filtering: false,
                title: Translate.transactionType,
                lookup: {
                    "deposit" :
                        <strong style={{color: "#38bf84",display:"flex",alignItems:'center'}}><AddRoundedIcon fontSize="small" style={{color:"#38bf84"}}/> {Translate.deposit}</strong>
                    , "withdraw":
                        <strong style={{color:"#BF8230",display:"flex",alignItems:'center'}}><RemoveRoundedIcon fontSize="small" style={{color:"#BF8230"}}/> {Translate.withdraw}</strong>
                },
            },
            { title: Translate.depositReal,
                field: 'amount',
                editable: 'never',
                filterPlaceholder: Translate.search,
                render: rowData => rowData.type === 'deposit' && <CurrencyFormat style={{color: "#38bf84",whiteSpace:"nowrap"}} value={rowData.amount} displayType={'text'} thousandSeparator={true}  suffix={" "+currencySymbol} />
            },
            { title: Translate.withdraw,
                field: 'amount',
                editable: 'never',
                filterPlaceholder: Translate.search,
                render: rowData =>  rowData.type === 'withdraw' &&  <CurrencyFormat style={{color:"#BF8230",whiteSpace:"nowrap"}} value={rowData.amount} displayType={'text'} thousandSeparator={true}  suffix={" "+currencySymbol} />
            },
            { title: Translate.description,
                field: 'description',
            },
            { title: Translate.status,
                editable: 'never',
                field: 'status',
                filterPlaceholder: Translate.choose,
                lookup: {
                    "confirmed" :
                        <Typography className="order_badge" style={{backgroundColor: colors.confirmed}}>{Translate.confirmed}</Typography>
                    , "pending":
                        <Typography className="order_badge" style={{backgroundColor: colors.pending}}>{Translate.pending}</Typography>
                    , "not_payed":
                        <Typography className="order_badge" style={{backgroundColor: colors.not_payed}}>{Translate.not_payed}</Typography>
                     , "removed":
                        <Typography className="order_badge" style={{backgroundColor: colors.unConfirmed}}>{Translate.removed}</Typography>
                },
            },
            {
                title: Translate.created_at,
                editable: 'never',
                field: 'created_at',
                render: rowData =>
                    <Typography className="date_in_table">
                        {`${moment(rowData.created_at).locale('fa').fromNow()}`}
                        <br/>
                        {`${moment(rowData.created_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}
                    </Typography>
            },
            { title: Translate.activity,
                editable: 'never',
                field: 'activity',
                render: rowData =>
                    <>
                        {
                            rowData.status === "not_payed" || rowData.status === "pending" ?
                                <GetConfirmationText
                                    tooltip={rowData.status === "pending" ? Translate.removeRequest : Translate.remove}
                                    size="small"
                                    variant="contained"
                                    style={{width:"100%",backgroundColor:"#f44336",color:"#fff"}}
                                    handleAction={() =>this.handleRemoveItem(rowData.id)}
                                >
                                    {rowData.status === "pending" ? Translate.removeRequest : Translate.remove}
                                </GetConfirmationText>
                                : null
                        }
                        {
                            rowData.status === "pending" ?
                                <>
                                    <PayWalletButton
                                        item={rowData}
                                        item_id={rowData.id}
                                        reload={() => this.loadData()}
                                    />
                                </>
                                : null

                        }
                    </>
            },


        ],
        data: [],
        loading:false,
        user:null,
        user_id:null,
        bank_info:null,
        amount:null,
        ChangeLoader:false,
        id:this.props.id,
        type:'all',
        beginDate: '',
        endDate: '',
    };
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    async handleBeginDate(beginDate){
        await this.setState({
            beginDate,
        })
        await this.loadData();
    }
    async handleEndDate(endDate){
        await this.setState({
            endDate
        })
        await this.loadData();
    }
    handleRemoveItem(id){
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/wallet/removeHistory-by-admin`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.dataRemoved, {
                    variant: 'success',
                });
                this.loadData();
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.dataRemovingFailed, {
                    variant: 'error',
                });

            });

        this.setState({
            loading:false,
            SubmitLoading:false
        });
    }
    handlePayedItem(id,refrence){
        if(!!refrence) {
            let data = new FormData();
            data.append('id', id);
            let loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.post(`${defaultVariabls.url}/wallet/payed`, data, config)
                .then(response => {
                    this.props.enqueueSnackbar(Translate.dataAdded, {
                        variant: 'success',
                    });
                    this.loadData();
                })
                .catch(error => {
                    this.props.enqueueSnackbar(Translate.dataAddingFailed, {
                        variant: 'error',
                    });

                });

            this.setState({
                loading:false,
                SubmitLoading:false
            });
        }else{
            this.props.enqueueSnackbar(Translate.addRefrenceIdFirst, {
                variant: 'warning',
            });
        }


    }
    onEditRow(row) {
        let authUser = getStore().user;
        if(authUser.role.permission.managePayments){
            let data = new FormData();
            data.append('id', row.id);
            data.append('refrence_id', row.refrence);
            data.append('description', row.description);

            let loginToken = localStorage.getItem('ACT');

            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.post(`${defaultVariabls.url}/wallet/history/quickEdit`, data, config)
                .then(response => {
                    this.props.enqueueSnackbar(Translate.detailsSet, {
                        variant: 'success',
                    });
                    this.loadData();
                    return true
                })
                .catch(error => {
                    console.log(error.response)
                    this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                        variant: 'error',
                    });
                    return false
                });
        }else{
            this.props.enqueueSnackbar(Translate.youDontHavePermission, {
                variant: 'error',
            });
            this.loadData();
        }

    }
    async handleChangeType(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let type = target.value;
        await this.setState({
            type
        });
        this.loadData();
    }
    render(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        let{user,amount,bank_info,type,beginDate,endDate} = this.state;
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl">
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Grid container spacing={2} className={this.classes.filterContainer}>
                                        <Grid item xs={12} md={3} lg={1}>
                                            <Typography>
                                                <FilterListRoundedIcon/>
                                                {Translate.filters}:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={3} lg={2}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                value={type}
                                                label={Translate.status}
                                                onChange={this.handleChangeType.bind(this)}
                                            >
                                                <MenuItem value='deposit'>{Translate.deposit}</MenuItem>
                                                <MenuItem value='withdraw'>{Translate.withdraw}</MenuItem>
                                                <MenuItem value='all'>{Translate.all}</MenuItem>
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={6} md={3} lg={2}>
                                            <ChooseDate
                                                size="small"
                                                noMargin
                                                variant="outlined"
                                                handleDate={this.handleBeginDate.bind(this)}
                                                label={Translate.chooseBeginDate}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={3} lg={2}>
                                            <ChooseDate
                                                size="small"
                                                noMargin
                                                variant="outlined"
                                                handleDate={this.handleEndDate.bind(this)}
                                                label={Translate.chooseEndDate}
                                            />
                                        </Grid>
                                        {
                                            (!!beginDate || !!endDate) &&
                                            <Grid item xs={6} md={3} lg={2}>
                                                <Button
                                                    style={{width:"100%"}}
                                                    color="secondary"
                                                    variant="outlined"
                                                    onClick={() => window.location.reload()}
                                                >
                                                    {Translate.removeFilter}
                                                </Button>
                                            </Grid>
                                        }
                                        <Grid item xs={6} md={3} lg={2}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                style={{width:"100%"}}
                                                component='a'
                                                target="_blank"
                                                startIcon={<PublishRoundedIcon/>}
                                                href={`${defaultVariabls.website}/export-transactions?id=${this.state.id}&type=${type}&begin_date=${beginDate}&end_date=${endDate}`}
                                            >
                                                {Translate.export}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <MaterialTable
                                        parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                                        tableRef={this.tableRef}
                                        icons={tableIcons}
                                        title={
                                            <Typography>
                                                <strong><Link to={'/manage/user/'+this.state.user_id}>{user}</Link> {!!bank_info ? <ViewUserBankInfo bank_info={bank_info}/> : null} </strong>
                                                {!!amount ? " ("+Translate.balance+" :" : null} {!!amount ? <CurrencyFormat value={amount} displayType={'text'} thousandSeparator={true}  suffix={" "+currencySymbol} /> : null}{!!amount ? ") ": null}
                                            </Typography>
                                        }
                                        localization={DataTableLocalization}
                                        columns={this.state.columns}
                                        detailPanel={rowData => {
                                            return (
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <SubTitleLight align="left">
                                                            {Translate.transactionTrackingCode}
                                                        </SubTitleLight>
                                                        <Typography>
                                                            {rowData.refrence}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <SubTitleLight align="left">
                                                            {Translate.bank_name}
                                                        </SubTitleLight>
                                                        <Typography>
                                                            {rowData.bank_name}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <SubTitleLight align="left">
                                                            {Translate.account_number}
                                                        </SubTitleLight>
                                                        <Typography className="date_in_table">
                                                            {rowData.account_number}<br/>
                                                            {!!rowData.sheba_number ? "IR"+rowData.sheba_number : ''}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            )
                                        }}
                                        data={query =>
                                            new Promise((resolve, reject) => {
                                                axios.get(`${defaultVariabls.url}/wallet/getHistory/${this.state.id}?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}&type=${type}&begin_date=${beginDate}&end_date=${endDate}`, config)
                                                    .then(response => {
                                                        console.log(beginDate)
                                                        let data = [];
                                                        // eslint-disable-next-line
                                                        response.data[1].data.map((row) => {
                                                            data.push({
                                                                amount: row.amount,
                                                                unique_code: row.unique_code,
                                                                id: row.id,
                                                                description: row.description,
                                                                status: row.status,
                                                                payment_link: row.payment_link,
                                                                type: row.type,
                                                                refrence: row.refrence_id,
                                                                bank_name: row.bank_name,
                                                                account_number: row.account_number,
                                                                sheba_number: row.sheba_number,
                                                                created_at: row.created_at,
                                                            })
                                                        });
                                                        this.setState({
                                                            user:response.data[0].user.first_name+" "+response.data[0].user.last_name,
                                                            user_id:response.data[0].user.id,
                                                            amount: response.data[0].amount,
                                                            bank_info:response.data[0].user.bank_info,
                                                        })
                                                        resolve({
                                                            data: data,
                                                            page: response.data[1].current_page - 1,
                                                            totalCount: response.data[1].total,
                                                        })
                                                    }).catch(error => {
                                                    console.log(error.response)
                                                })
                                            })
                                        }
                                        options={{
                                            pageSize: TablePage,
                                            pageSizeOptions: TableCount,
                                            defaultExpanded:true,
                                        }}
                                        editable={{
                                            onRowUpdate: (newData, oldData) =>
                                                new Promise(resolve => {
                                                    setTimeout(() => {
                                                        resolve();
                                                        this.onEditRow(newData);
                                                        if (oldData) {
                                                            this.setState(prevState => {
                                                                const data = [...prevState.data];
                                                                data[data.indexOf(oldData)] = newData;
                                                                return { ...prevState, data };
                                                            });
                                                        }
                                                    }, 600);
                                                }),
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Container>
                }
            </>

        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Wallet)))));